<header>
  <app-header></app-header>
  <app-navbar></app-navbar>
</header>
<body>
  <div class="card">
    <div class="card-header text-center" style="background-color: #be0c4d;">
      <h5 style="color: white;">Administración Información Financiación Vivienda</h5>
    </div>
    <div class="card-body">
      <div class="row">
        <button type="button" class="btn btn-secondary col-auto" style="margin-left: 20px;" (click)="RegresarAdminInf()">Volver</button>
      </div>
      <div>
        <br>
        <div class="row">
          <button type="button" class="btn btn-secondary col-6" style="margin: auto;" (click)="IrConsultaInformacion()">Consultar información</button>
        </div>
        <br>
        <div class="row">
          <button type="button" class="btn btn-secondary col-6" style="margin: auto;" (click)="IrCargueMasivoInformacion()">Cargue masivo</button>
        </div>
        <br>
        <div class="row">
          <button type="button" class="btn btn-secondary col-6" style="margin: auto;" (click)="IrActivarCargue()">Activar/Inactivar cargue</button>
        </div>
        <br>
        <div class="row">
          <button type="button" class="btn btn-secondary col-6" style="margin: auto;" (click)="IrCrearNovedad()">Crear novedad</button>
        </div>
        <br>
      </div>
    </div>
  </div>
</body>
